import { BASE_URL } from "../BaseUrl.js";
import axios from "axios";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("cc_pssm_api");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    config.headers.Authorization = null;
  }

  return config;
});

export const loginAdmin = async (values) => {
  return await axios.post(BASE_URL("auth/login"), values);
};

export const changePasswordAdmin = async (values) => {
  return await axios.post(BASE_URL("auth/changermotdepasse"), values);
};

export const resetPasswordAdmin = async (values) => {
  return await axios.post(BASE_URL("reinitialiserpassword"), values);
};

export const recupererProfilUtilisateurConnecte = async (userID) => {
  return await axios.get(BASE_URL(`metier/recuperer-profil/${userID}`), {});
};
